import { atomWithStorage } from "jotai/utils";
import { userObject } from "app/api/user/user.types";
import { storageKey } from "app/utils/storageKeys";
import { atom } from "jotai";

export const userAtom = atomWithStorage<userObject | null>(storageKey.user, null);
export const needsToLoginAtom = atom<boolean>(false);